import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CustomButton from "./CustomButton";
import "../css/StockistDetails.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
const StockistDetails = () => {
  const [stockists, setStockists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { employeeId } = useParams();
  const location = useLocation();
  const {
    fromDCSAssigned,
    selectedState,
    selectedEmployee,
    tableData,
    states,
    employees,
  } = location.state || {};

  useEffect(() => {
    const fetchStockists = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/stockist/list?employee_id=${employeeId}&purpose=assign&report=True
`,
          {
            headers: getAuthHeaders(),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setStockists(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    if (employeeId) {
      fetchStockists();
    }
  }, [employeeId]);

  const handlePrint = () => {
    window.print();
  };

  const handleExportExcel = () => {
    console.log("Exporting to Excel...");
  };

  const renderField = (field) => {
    if (typeof field === "object" && field !== null) {
      return field.name || field.id || "";
    }
    return field || "";
  };

  if (loading) {
    return <div>Loading stockist details...</div>;
  }

  if (error) {
    return <div>Error loading stockist details: {error}</div>;
  }

  if (stockists.length === 0) {
    return (
      <div className="no-data-message">
        No stockist data found for this employee.
      </div>
    );
  }

  return (
    <div className="stockist-data-container">
      <div className="stockist-heading-container">
        <h1 className="stockist-title">Stockist Details</h1>
      </div>

      <div className="border rounded shadow  table-wrapper">
        <table className="unlock-dcr-leave-table text-sm ">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th>S.No</th>
              <th>Stockist</th>
              {/* <th>Route</th>
                <th>DOB</th> */}
              <th>Phone</th>
              <th>Address</th>
              <th>HQ</th>
              <th>State</th>
              <th>City</th>
            </tr>
          </thead>
          <tbody>
            {stockists.map((stockist, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{renderField(stockist.stockist_name)}</td>
                {/* <td>{renderField(stockist.route)}</td>
                  <td>{renderField(stockist.dob)}</td> */}
                <td>{renderField(stockist.mobile)}</td>
                <td>{renderField(stockist.address)}</td>
                <td>{renderField(stockist.headquarter_name)}</td>
                <td>{renderField(stockist.state_name)}</td>
                <td>{renderField(stockist.city_name)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex gap-4 justify-center">
        <CustomButton onClick={handlePrint} label="Print" variant="print">
          🖨
        </CustomButton>
        <CustomButton
          onClick={handleExportExcel}
          label="Export"
          variant="export"
        >
          📥
        </CustomButton>
      </div>
    </div>
  );
};

export default StockistDetails;
